export default __webpack_public_path__ + "static/FeatureTwo-3077e40236a1a723f6807e6cd5644286.webp";